/*
 * @Description: 单选框
 * @Author: oubu
 * @Date: 2020-03-03
 */
import React from 'react';
import './index.less';
import Config from 'config/Config';

const CDN_BASE = Config.CDN_BASE || '';

const Radio = (props) => {
  const { checked, disabled, onClick, redStyle, Icon } = props;
  let scr = '';
  if (disabled) {
    if (checked) {
      scr = '/assets/imgs/widget/CheckBox/icon-checked-disable.svg';
    } else {
      scr = '/assets/imgs/widget/CheckBox/icon-unchecked-disable.svg';
    }
  } else {
    if (checked) {
      if (Icon) {
        scr = 'icon-danxuankuangxuanzhong color-main';
      } else {
        scr = '/assets/imgs/widget/CheckBox/icon-checked.png';
        if (redStyle) {
          scr = '/assets/imgs/widget/CheckBox/icon-checked-copy.png';
        }
      }
    } else {
      scr = '/assets/imgs/widget/CheckBox/icon-unchecked.png';
    }
  }

  return scr.indexOf('assets') >= 0 ? (
    <img
      src={CDN_BASE + scr}
      className="common-checkbox"
      onClick={(e) => {
        if (!disabled) {
          onClick && onClick(e);
        }
      }}
    />
  ) : (
    <span className={`iconfont ${scr}`} />
  );
  // <img
  //   className = 'common-radio'
  //   src = {CDN_BASE + scr}
  //   onClick = {e => {
  //     if (!disabled) {
  //       onClick && onClick(e);
  //     }
  //   }}
  // />
};

export default Radio;



// WEBPACK FOOTER //
// ./src/widget/Radio/index.js